import { render, staticRenderFns } from "./BrPendingApproval.vue?vue&type=template&id=479881e8&"
import script from "./BrPendingApproval.vue?vue&type=script&lang=js&"
export * from "./BrPendingApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports